import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import SAFETY_TRUCK_MODAL_DEFAULT_VALUE from '../../../../constant/Safety/Truck/Modal/defaultValue';
import getSpecificTruckData from '../../../../service/Safety/Truck/Get/getSpecificTruckData';
import safetyTruckKeys from '../keys';
import { ALERT_MODAL_STATUS } from '../../../../constant/Common/Modal/Alert/status';

const useGetSpecificTruckData = ({ seq, isModalOpen, ...props }) => {
  const { setAlertOpen, setAlertModalStatus } = props;

  const [specificData, setSpecificData] = useState({
    ...SAFETY_TRUCK_MODAL_DEFAULT_VALUE,
  });

  const query = useQuery({
    queryKey: safetyTruckKeys?.specificData({ seq }),
    queryFn: () => getSpecificTruckData({ seq }),
    refetchOnWindowFocus: false,
    enabled: !!seq && !!isModalOpen,
  });

  useEffect(() => {
    if (query?.data) {
      setSpecificData(prev => query?.data?.data);
    } else {
      setSpecificData(prev => {
        return {
          ...SAFETY_TRUCK_MODAL_DEFAULT_VALUE,
        };
      });
    }
  }, [query?.data]);

  useEffect(() => {
    if (query?.isError) {
      setAlertModalStatus(prev => {
        return {
          status: ALERT_MODAL_STATUS.ERROR,
          message: query?.error?.message,
        };
      });
      setAlertOpen(prev => true);
    }
  }, [query?.isError]);

  return { specificData, ...query };
};

export default useGetSpecificTruckData;
